import React from 'react';
import { string, bool, arrayOf, shape, number } from 'prop-types';
import * as styles from './styles/styles.module.scss';
import SeoTabCard from './SeoTabCard';
import { MapStatsUtil } from '../../../../utils/map_stats_util';
import { LanguageSupportUtil } from '../../../../utils/language_support_util';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import chunks from '../../../../utils/chunks';
import { EN_US } from '../../../../utils/constants/LanguageRegionCode';

const {
  strings: { TRAIL, TRAILS }
} = StringConstantsMixin;

const SeoTabbedContent = ({ cards, languageRegionCode, displayMetric }) => {
  const getDistanceAndTimeString = ({ distance, time }) => {
    const formattedDistance = MapStatsUtil.metersToFormattedUserUnits(distance, 1, displayMetric, languageRegionCode);
    const formattedTime = MapStatsUtil.minutesToFormattedTime(time);
    let label = `${formattedDistance}`;

    if (formattedTime) {
      label += ` • ${formattedTime}`;
    }

    return label;
  };

  const getNumberOfTrailString = trailNum => {
    const trailString = trailNum === 1 ? TRAIL : TRAILS;

    return `${MapStatsUtil.formatData(trailNum, 0, null, languageRegionCode)} ${trailString}`;
  };

  const cardProps = card => {
    const subtext = card.numberOfTrails ? getNumberOfTrailString(card.numberOfTrails) : getDistanceAndTimeString(card);

    return {
      subtext,
      title: card.title,
      imgSrc: card.imgSrc,
      url: LanguageSupportUtil.wrapUrlSafe(`${card.url}?ref=homepage_seotabbed`, languageRegionCode)
    };
  };

  const chunkedCards = [
    ...chunks(
      cards.filter(card => card.title),
      4
    )
  ];

  return (
    <div className={styles.container}>
      {chunkedCards.map(cardRows => {
        return (
          <div key={cardRows[0].title}>
            {cardRows.map(card => (
              <SeoTabCard {...cardProps(card)} key={card.title} />
            ))}
          </div>
        );
      })}
    </div>
  );
};

SeoTabbedContent.propTypes = {
  cards: arrayOf(
    shape({
      distance: number,
      imgSrc: string,
      time: string,
      title: string,
      url: string
    })
  ),
  languageRegionCode: string,
  displayMetric: bool
};

SeoTabbedContent.defaultProps = {
  cards: [],
  languageRegionCode: EN_US,
  displayMetric: false
};

export default SeoTabbedContent;
